<p-panel>
  <ng-template #header>
    <div class="flex justify-between items-center mb-8 p-2 w-full">
      <h1 class="m-0 font-semibold text-gray-800">Tierheim-Übersicht</h1>
      <p-button
        label="Neues Tierheim"
        icon="pi pi-plus"
        (onClick)="openNewShelterDialog()">
      </p-button>
    </div>
  </ng-template>

  <p-table
    [value]="shelters"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Tierheimen"
    [tableStyle]="{'min-width': '50rem'}"
    [globalFilterFields]="['title', 'city', 'zipCode']">

    <ng-template pTemplate="header">
      <tr class="bg-gray-100 text-gray-700 font-semibold">
        <th>{{ 'animalShelter.overview.name' | transloco }}</th>
        <th>{{ 'animalShelter.overview.address' | transloco }}</th>
        <th>{{ 'animalShelter.overview.zipCode' | transloco }}</th>
        <th>{{ 'animalShelter.overview.city' | transloco }}</th>
        <th>{{ 'animalShelter.overview.phoneNumber' | transloco }}</th>
        <th>{{ 'animalShelter.overview.mailAddress' | transloco }}</th>
        <th>{{ 'animalShelter.overview.actions' | transloco }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-shelter>
      <tr class="hover:bg-gray-100">
        <td class="py-3">{{ shelter.title }}</td>
        <td class="py-3">{{ shelter.address }}</td>
        <td class="py-3">{{ shelter.zipCode }}</td>
        <td class="py-3">{{ shelter.city }}</td>
        <td class="py-3">{{ shelter.phoneNumber }}</td>
        <td class="py-3">{{ shelter.mailAddress }}</td>
        <td class="py-3">
          <div class="flex gap-2">
            <p-button
              icon="pi pi-pen-to-square"
              label=""
              [rounded]="true"
              pTooltip="Tierheim bearbeiten"
              (onClick)="editShelter(shelter)"
            />
            <p-button
              icon="pi pi-users"
              label=""
              [rounded]="true"
              severity="secondary"
              pTooltip="Vorstandsmitglieder verwalten"
              (onClick)="openUsersDialog(shelter)"
            />
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [header]="isEditMode ? 'Tierheim bearbeiten' : 'Neues Tierheim'"
    [(visible)]="displayDialog"
    [modal]="true"
    [blockScroll]="true"
    [style]="{width: '450px'}"
    [draggable]="false"
    [resizable]="false">

    <!-- Formular-Wrapper für Template-driven Validation -->
    <form #shelterForm="ngForm" novalidate>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <label for="title" class="field-title">Name *</label>
          <input
            id="title"
            name="title"
            type="text"
            pInputText
            required
            [(ngModel)]="selectedShelter.title"
            placeholder="Name des Tierheims"
            class="w-full">
          <small class="text-red-600" *ngIf="shelterForm.submitted || shelterForm.form.get('title')?.touched">
            <span *ngIf="shelterForm.form.get('title')?.hasError('required')">Name ist erforderlich.</span>
          </small>
        </div>

        <div class="flex flex-col gap-2">
          <label for="address" class="field-title">Adresse *</label>
          <input
            id="address"
            name="address"
            type="text"
            pInputText
            required
            [(ngModel)]="selectedShelter.address"
            placeholder="Straße und Hausnummer"
            class="w-full">
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col gap-2">
            <label for="zipCode" class="field-title">PLZ *</label>
            <input
              id="zipCode"
              name="zipCode"
              type="text"
              pInputText
              required
              [(ngModel)]="selectedShelter.zipCode"
              placeholder="PLZ"
              class="w-full">
          </div>

          <div class="flex flex-col gap-2">
            <label for="city" class="field-title">Stadt *</label>
            <input
              id="city"
              name="city"
              type="text"
              pInputText
              required
              [(ngModel)]="selectedShelter.city"
              placeholder="Stadt"
              class="w-full">
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <label for="phoneNumber" class="field-title">Telefonnummer *</label>
          <input
            id="phoneNumber"
            name="phoneNumber"
            type="text"
            pInputText
            required
            [(ngModel)]="selectedShelter.phoneNumber"
            #phone="ngModel"
            placeholder="Telefonnummer"
            class="w-full">
          <small class="text-red-600" *ngIf="(phone.invalid && (phone.dirty || phone.touched)) || (shelterForm.submitted && phone.invalid)">
            <span *ngIf="phone.errors?.['required']">Telefonnummer ist erforderlich.</span>
          </small>
        </div>

        <div class="flex flex-col gap-2">
          <label for="mailAddress" class="field-title">E-Mail-Adresse *</label>
          <input
            id="mailAddress"
            name="mailAddress"
            type="email"
            pInputText
            required
            [(ngModel)]="selectedShelter.mailAddress"
            #mail="ngModel"
            placeholder="E-Mail-Adresse"
            class="w-full">
          <small class="text-red-600" *ngIf="(mail.invalid && (mail.dirty || mail.touched)) || (shelterForm.submitted && mail.invalid)">
            <span *ngIf="mail.errors?.['required']">E-Mail ist erforderlich.</span>
            <span *ngIf="mail.errors?.['email']">Bitte eine gültige E-Mail-Adresse eingeben.</span>
          </small>
        </div>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-2">
        <p-button
          label="Abbrechen"
          icon="pi pi-times"
          [text]="true"
          (onClick)="hideDialog()">
        </p-button>
        <p-button
          [label]="isEditMode ? 'Aktualisieren' : 'Erstellen'"
          icon="pi pi-save"
          (onClick)="saveShelter()"
          [disabled]="!shelterForm.form.valid">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- User Management Dialog -->
  <p-dialog
    header="Vorstandsmitglieder verwalten"
    [(visible)]="displayUsersDialog"
    [modal]="true"
    [blockScroll]="true"
    [style]="{width: '500px'}"
    [draggable]="false"
    [resizable]="false"
    (onHide)="hideUsersDialog()">

    <div class="flex flex-col gap-4">
      <div class="text-gray-600 font-semibold">
        Tierheim: <span class="text-gray-900">{{ selectedShelterForUsers?.title }}</span>
      </div>

      <!-- Add User -->
      <div class="flex flex-col gap-2">
        <label class="field-title">Benutzer hinzufügen</label>
        <div class="flex gap-2">
          <p-select
            [(ngModel)]="selectedNewUser"
            [options]="availableUsers"
            [filter]="true"
            filterBy="name,displayName"
            [showClear]="true"
            placeholder="Benutzer auswählen..."
            [loading]="loadingAllUsers"
            class="flex-1 w-full">
            <ng-template pTemplate="selectedItem" let-user>
              <span *ngIf="user">{{ getUserDisplayLabel(user) }}</span>
            </ng-template>
            <ng-template pTemplate="item" let-user>
              <div class="flex flex-col">
                <span class="font-medium">{{ user.displayName || user.name }}</span>
                <span class="text-xs text-gray-500" *ngIf="user.displayName">{{ user.name }}</span>
              </div>
            </ng-template>
          </p-select>
          <p-button
            icon="pi pi-plus"
            label="Hinzufügen"
            [disabled]="!selectedNewUser"
            (onClick)="addUserToShelter()">
          </p-button>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- User List -->
      <div class="flex flex-col gap-2">
        <label class="field-title">Aktuelle Vorstandsmitglieder</label>
        <div *ngIf="loadingUsers" class="flex justify-center p-4">
          <p-progressSpinner [style]="{width: '32px', height: '32px'}"></p-progressSpinner>
        </div>
        <div *ngIf="!loadingUsers && shelterUsers.length === 0" class="text-gray-500 text-sm">
          Keine Vorstandsmitglieder zugeordnet.
        </div>
        <div *ngFor="let user of shelterUsers" class="flex items-center justify-between p-2 bg-gray-50 rounded border border-gray-200">
          <div class="flex flex-col">
            <span class="font-medium">{{ user.displayName || user.name }}</span>
            <span class="text-xs text-gray-500">ID: {{ user.id }}</span>
          </div>
          <p-button
            icon="pi pi-trash"
            [rounded]="true"
            severity="danger"
            [text]="true"
            pTooltip="Benutzer entfernen"
            (onClick)="removeUserFromShelter(user.id)">
          </p-button>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-end">
        <p-button
          label="Schließen"
          icon="pi pi-times"
          [text]="true"
          (onClick)="hideUsersDialog()">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>
</p-panel>
